
import React, { Component } from "react";

import { Card } from 'antd';

import QRCodeComponent from "./QrCode";

import _ from "lodash"
import moment from "moment"


const { Meta } = Card;


class ComponentToPrint extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    render() {

        const type = _.get(this.props, "type", "coupon")

        let date = new Date()

        const printDate = `${date.getDate()} ${moment(date).format("MMM")} ${moment(date).format("ddd")} ${new Date(date).getHours()}:${new Date(date).getMinutes()}`

        if (type == "coupon") {
            return (
                <div>
                    <div className="header-coupon">
                        <img src="https://emedya-cdn.tjk.org/dist/images/logo.svg" width={54} />
                        <h2 style={{
                            //textAlign: 'center'
                        }}>TÜRKİYE JOKEY KULÜBÜ</h2>
                    </div>

                    <div className="border-bottom" style={{ marginTop: 10 }}>
                        <p>
                            {` ${printDate} | ${_.get(this.props, "state.text", "")}`}
                        </p>
                    </div>


                    <b>{` ${_.get(this.props, "state.selectedBahis.text", "")}`}</b>

                    <p>
                        M{_.get(this.props.state, "much", "")}
                    </p>

                    <div>
                        Koşu <b>{` ${_.get(this.props, "state.selectedBahis.children.text", "")}`}</b>
                    </div>



                    <div className="border-bottom" />

                    <div>
                        <table style={{ backgroundColor: "#fff", padding: 5 }} >
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    _.get(this.props, "state.runs", []).map((item, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    {i + 1} {` > `}
                                                </td>
                                                <td>
                                                    {
                                                        _.get(item, "atlar", []).map((v, i) => {
                                                            if (_.get(item, "atlar", []).length != i + 1) {
                                                                return (
                                                                    <span key={i}>
                                                                        {v.NO}
                                                                        {`, `}
                                                                    </span>
                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    <span key={i}>
                                                                        {v.NO}
                                                                    </span>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="border-bottom" />
                    <div>
                        <b>BAH.TOP : {_.get(this.props, "state.priceFormated")} ₺</b>
                    </div>


                    <div style={{
                        padding: 10,
                        // textAlign: 'center' 
                    }}>
                        {new Date(_.get(this.props, "state.created", new Date())).getTime()}
                    </div>


                    <div style={{
                        padding: 10,
                        // textAlign: 'center'
                    }}>
                        <QRCodeComponent text={_.get(this.props, "state._id")} />
                    </div>
                </div>
            )
        }
        else {
            return (
                <div>
                    {
                        //JSON.stringify(this.props.state)
                    }
                </div>
            );
        }

    }
}


export default ComponentToPrint